type SectionRailProps = {
  index: string;
  kicker: string;
  meta?: string;
};

// The design system's universal section header: mono index, uppercase
// kicker, flex spacer, mono metadata over a hairline.
export const SectionRail = ({ index, kicker, meta }: SectionRailProps) => (
  <div className="flex items-baseline gap-6 border-b pb-4">
    <span className="min-w-12 shrink-0 font-mono text-xs tracking-[0.5px] text-primary">
      {index}
    </span>
    <span className="shrink-0 font-mono text-xs uppercase tracking-[1.2px] text-muted-foreground">
      {kicker}
    </span>
    <span className="flex-1" />
    {meta ? (
      <span className="hidden font-mono text-[11px] tracking-[0.5px] text-subtle sm:block">
        {meta}
      </span>
    ) : null}
  </div>
);
